import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";

function SixteenElite() {
  return (
    <>
    <Navbar2 />
      <div className='container-fluid px-0 pb-4 pt-5'>
        <div className="row">
            <div className="col">
              <div className='h1 text-center'>16 Elite
                <br />2025-2026 Club Roster
              </div>
            </div>
          </div>
      </div>
      <div className="container-fluid text-center">
         <div class="row justify-content-center">
          <div class="col-3">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title">Kelli Hardge</h5>
                <p className="card-text">Head Coach</p>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title">Jessica Cantu</h5>
                <p className="card-text">Assistant Coach</p>
              </div>
            </div>
          </div>
        </div>
      
        <div className="row text-center">
          <div className="col p-5 text-center">
            <table class="table table-striped table-bordered table-hover">
              <thead class="table-dark">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Primary Position</th>
                  <th scope="col">Jersey #</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Cecilia Villanueva</td>
                  <td>DS</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td>Paris Brown</td>
                  <td>OH</td>
                  <td>4</td>
                </tr>
                <tr>
                  <td>Colbie Cummings</td>
                  <td>S</td>
                  <td>5</td>
                </tr>
                <tr>
                  <td>Ayla Matias</td>
                  <td>DS</td>
                  <td>8</td>
                </tr>
                <tr>
                  <td>Juliana Ramirez</td>
                  <td>L</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>Adalia Resendez</td>
                  <td>OP</td>
                  <td>12</td>
                </tr>
                <tr>
                  <td>Carlynn Gaston</td>
                  <td>M</td>
                  <td>14</td>
                </tr>
                <tr>
                  <td>Ava Robinson</td>
                  <td>DS</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td>Jaylin Hinojosa</td>
                  <td>DS</td>
                  <td>17</td>
                </tr>
                <tr>
                  <td>London Barnes</td>
                  <td>M</td>
                  <td>21</td>
                </tr>
                <tr>
                  <td>Bella Mata</td>
                  <td>OH</td>
                  <td>22</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SixteenElite;
